var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_4._Twitter",
    "data-name": "4. Twitter",
    d: "M51.5,103A51.513,51.513,0,0,1,31.454,4.047,51.513,51.513,0,0,1,71.546,98.953,51.178,51.178,0,0,1,51.5,103ZM21.569,75.556h0a36.67,36.67,0,0,0,20.056,5.926c23.355,0,37.31-18.977,37.31-37.324,0-.57-.014-1.139-.04-1.692a26.551,26.551,0,0,0,6.536-6.793,26.545,26.545,0,0,1-7.524,2.071,13.116,13.116,0,0,0,5.765-7.254,25.988,25.988,0,0,1-8.323,3.18A13.1,13.1,0,0,0,52.682,42.63a12.855,12.855,0,0,0,.338,2.991,36.836,36.836,0,0,1-15.171-4.079,37.106,37.106,0,0,1-11.842-9.63,13.13,13.13,0,0,0,4.073,17.511,12.87,12.87,0,0,1-5.954-1.637v.162A13.143,13.143,0,0,0,34.642,60.8a13.164,13.164,0,0,1-3.452.46,12.408,12.408,0,0,1-2.462-.243,13.1,13.1,0,0,0,12.247,9.107A26.268,26.268,0,0,1,24.7,75.746,26.779,26.779,0,0,1,21.569,75.556Z",
    fill: "#59a7cf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7a93c430d38343590861ae2502901f87.svg";
export { ForwardRef as ReactComponent };